angular.module('picmonicng').directive('learnPauseAudio', [
  'LearnService',
  function (LearnService) {
    return {
      restrict: 'A',
      link: function (scope, element) {
        element.bind('click', function (event) {
          scope.$apply(function () {
            if (LearnService.audioElement) {
              LearnService.audioElement.pause();
            }
          });
        });
      },
    };
  },
]);
